import React from 'react';

const Footer = () => {
    return (
        <footer className="c-section-container">
            <ul className="l-footer">
                <a className="u-text__link-none" href="https://teien.atrise.work/contact.html" target="_blank" rel="noreferrer noopener">
                    <li>お問い合わせ</li>
                </a>
                <a className="u-text__link-none" href="https://atrise.work" target="_blank" rel="noreferrer noopener">
                    <li>運営者</li>
                </a>
                <a className="u-text__link-none" href="https://winefile.net/contact.php#agreement" target="_blank" rel="noreferrer noopener">
                    <li>利用規約</li>
                </a>
                <a className="u-text__link-none" href="https://winefile.net/contact.php#privacy" target="_blank" rel="noreferrer noopener">
                    <li>プライバシーポリシー</li>
                </a>
            </ul>
            <div className="module-spacer--extra-extra-small" />
            <div>
                <a className="u-text__link-none" href="https://atrise.work" target="_blank" rel="noreferrer noopener">
                    &copy; 2020 @rise
                </a>
            </div>
        </footer>
    );
};

export default Footer;